var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0984 2.49221C13.5377 2.05287 13.5377 1.34056 13.0984 0.901221C12.659 0.461881 11.9467 0.461881 11.5074 0.901221L6.9996 5.40902L2.4918 0.901222C2.05246 0.461882 1.34015 0.461882 0.900808 0.901222C0.461468 1.34056 0.461468 2.05287 0.900808 2.49221L5.40861 7.00001L0.900794 11.5078C0.461454 11.9472 0.461454 12.6595 0.900794 13.0988C1.34013 13.5382 2.05244 13.5382 2.49178 13.0988L6.9996 8.591L11.5074 13.0988C11.9467 13.5382 12.6591 13.5382 13.0984 13.0988C13.5377 12.6595 13.5377 11.9472 13.0984 11.5078L8.59059 7.00001L13.0984 2.49221Z",
    fill: "#EB9F1A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.708b27f44204626b71a3e7faafa00f38.svg";
export { ForwardRef as ReactComponent };